module.exports = __webpack_public_path__ + "static/img/logo.2c82385.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/hsm/img/logo.png
// module id = MmWr
// module chunks = 1